export const DB_NAME = "japangolmok";
export const DB_VERSION = 3;
export const COMPANION_STORE = "companion-plans";
export const ARRIVAL_CARD_STORE = "arrival-cards";
export const TRIP_STORE = "trips";

export const openDb = () =>
	new Promise<IDBDatabase>((resolve, reject) => {
		let blocked = false;
		const request = indexedDB.open(DB_NAME, DB_VERSION);
		request.onupgradeneeded = () => {
			const db = request.result;
			if (!db.objectStoreNames.contains(ARRIVAL_CARD_STORE))
				db.createObjectStore(ARRIVAL_CARD_STORE, { keyPath: "id" });
			if (!db.objectStoreNames.contains(TRIP_STORE))
				db.createObjectStore(TRIP_STORE, { keyPath: "id" });
			if (!db.objectStoreNames.contains(COMPANION_STORE))
				db.createObjectStore(COMPANION_STORE, { keyPath: "id" });
		};
		request.onsuccess = () => {
			if (blocked) {
				request.result.close();
				return;
			}
			request.result.onversionchange = () => request.result.close();
			resolve(request.result);
		};
		request.onerror = () => reject(request.error);
		request.onblocked = () => {
			blocked = true;
			reject(new Error("INDEXED_DB_UPGRADE_BLOCKED"));
		};
	});

export const extensionStores = ["profile", "saved-walks", "trash"];
export function openStoreDb(store: string): Promise<IDBDatabase> {
	if (!extensionStores.includes(store)) return openDb();
	return new Promise((resolve, reject) => {
		const req = indexedDB.open("japangolmok-local-extras", 1);
		req.onupgradeneeded = () => {
			for (const name of extensionStores)
				if (!req.result.objectStoreNames.contains(name))
					req.result.createObjectStore(name, { keyPath: "id" });
		};
		req.onsuccess = () => {
			req.result.onversionchange = () => req.result.close();
			resolve(req.result);
		};
		req.onerror = () => reject(req.error);
		req.onblocked = () => reject(new Error("INDEXED_DB_UPGRADE_BLOCKED"));
	});
}

export async function putRecord<T>(storeName: string, value: T) {
	const db = await openStoreDb(storeName);
	try {
		await new Promise<void>((resolve, reject) => {
			const tx = db.transaction(storeName, "readwrite");
			tx.objectStore(storeName).put(value);
			tx.oncomplete = () => resolve();
			tx.onerror = () => reject(tx.error);
			tx.onabort = () =>
				reject(tx.error ?? new Error("INDEXED_DB_TRANSACTION_ABORTED"));
		});
	} finally {
		db.close();
	}
}

export async function getRecord<T>(storeName: string, id: string) {
	const db = await openStoreDb(storeName);
	try {
		return await new Promise<T | undefined>((resolve, reject) => {
			const request = db.transaction(storeName).objectStore(storeName).get(id);
			request.onsuccess = () => resolve(request.result as T | undefined);
			request.onerror = () => reject(request.error);
		});
	} finally {
		db.close();
	}
}

export async function getAllRecords<T>(storeName: string) {
	const db = await openStoreDb(storeName);
	try {
		return await new Promise<T[]>((resolve, reject) => {
			const request = db.transaction(storeName).objectStore(storeName).getAll();
			request.onsuccess = () => resolve(request.result as T[]);
			request.onerror = () => reject(request.error);
		});
	} finally {
		db.close();
	}
}

export async function deleteRecord(storeName: string, id: string) {
	const db = await openStoreDb(storeName);
	try {
		await new Promise<void>((resolve, reject) => {
			const tx = db.transaction(storeName, "readwrite");
			tx.objectStore(storeName).delete(id);
			tx.oncomplete = () => resolve();
			tx.onerror = () => reject(tx.error);
		});
	} finally {
		db.close();
	}
}
